import { render } from "./DashboardDataSelector.vue?vue&type=template&id=ed0593ea&scoped=true"
import script from "./DashboardDataSelector.vue?vue&type=script&lang=js"
export * from "./DashboardDataSelector.vue?vue&type=script&lang=js"

import "./DashboardDataSelector.vue?vue&type=style&index=0&id=ed0593ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0593ea"]])

export default __exports__